import { isMotionValue as i } from "./atoms-v2884.js";
function t(o) {
  return !!(i(o) && o.add);
}
export {
  t as isWillChangeMotionValue
};
